/**
 * 开始轨道对话框
 */

import { useState } from 'react'

import { TeamMemberSelector } from '@/components/pm/issue/team-member-selector'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'

import { TRACK_DISPLAY_NAMES } from '../workflow-constants'

import type { TrackType } from '@company/shared'

// ==================== 类型定义 ====================

interface StartTrackDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  track: TrackType
  teamId?: string
  onConfirm: (assigneeId: string) => void
  loading?: boolean
  error?: string | null
}

// ==================== 组件实现 ====================

export function StartTrackDialog({
  open,
  onOpenChange,
  track,
  teamId,
  onConfirm,
  loading = false,
  error,
}: StartTrackDialogProps) {
  const [selectedAssigneeId, setSelectedAssigneeId] = useState('')

  const trackName = TRACK_DISPLAY_NAMES[track]

  const handleConfirm = () => {
    if (!selectedAssigneeId) {
      return
    }
    onConfirm(selectedAssigneeId)
  }

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      setSelectedAssigneeId('')
    }
    onOpenChange(open)
  }

  return (
    <AlertDialog open={open} onOpenChange={handleOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>开始{trackName}开发</AlertDialogTitle>
          <AlertDialogDescription>请选择开发负责人</AlertDialogDescription>
        </AlertDialogHeader>

        <div className="py-4">
          {teamId ? (
            <TeamMemberSelector
              teamId={teamId}
              mode="single"
              value={selectedAssigneeId}
              onChange={(value) => setSelectedAssigneeId(value as string)}
              placeholder="选择开发人员"
              trackType={track}
            />
          ) : (
            <div className="text-muted-foreground text-sm">未配置团队，无法选择成员</div>
          )}

          {/* 错误提示 */}
          {error && (
            <div className="bg-destructive/10 text-destructive mt-4 rounded-md p-3 text-sm">
              {error}
            </div>
          )}
        </div>

        <AlertDialogFooter>
          <AlertDialogCancel>取消</AlertDialogCancel>
          <AlertDialogAction
            onClick={handleConfirm}
            disabled={loading || !selectedAssigneeId}
            className="bg-blue-600 hover:bg-blue-700"
          >
            {loading ? '处理中...' : '开始开发'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
